import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

import { useHistory, useParams } from 'react-router-dom';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';

import * as helpers from './helpers.js'
import * as globals from './globals.js'
import * as Actions from './redux-actions.js'


import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

import SyncIcon from '@material-ui/icons/Sync';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const clone = require('rfdc')()





export const price_columns = [
  { id: 'price_azn', label: 'AZN', minWidth: 100 },
  { id: 'price_eur', label: 'EUR', minWidth: 100 },
];

export const region_columns = [
  { id: 'name', label: 'Region name', minWidth: 200 },
];



const useStyles = makeStyles((theme) => ({
  root: {
      width: "100%",
  },
  container: {
    width: "200px",
    maxHeight: props => props.maxHeight || 10000,
  },
}));



function Prices(props) {
  const { p1 } = useParams()
  const classes = useStyles()
  const history = useHistory()
  const serverStatus = useSelector(state => state.serverStatus)
  const authenticated = useSelector(state => state.authenticated)
  const current_role = useSelector(state => state.current_role)
  const prices = useSelector(state => state.dictionary.transfer_price)
  const regions = useSelector(state => state.dictionary.az_regions)
  const cars = useSelector(state => state.dictionary.cars)
  
  const dispatch = useDispatch()
  const [loaded, setLoaded] = useState(true);
  const [apiCallInProgress, setApiCallInProgress] = useState(false);
  const [refresh, setRefresh] = useState(true)
  const [transferType, setTransferType] = useState(1)
  

  useEffect(() => {
     
     if (serverStatus) {
       setLoaded(false)
       helpers.getAPI(
         { func: function(resp) {
                 dispatch({type: Actions.LOAD_DICTIONARY,  value: resp})
                 setLoaded(true)
               }, 
           uri: globals.myAPIurl+'/getdict'
         })

     }

  }, [refresh]);


  const refreshData = () => {
     setRefresh(!refresh)
  }


  if (! prices || ! regions ) return (<div className="section has-background-light">
                          <CircularProgress />
                        </div>)
  


  return (
  	<div>
     <div className="columns is-mobile">
       <div className="column is-10">
    

     </div>

     <div className="column is-2 has-text-right">
     
       <IconButton
        variant="contained"
        color="secondary"
        onClick={refreshData}>
         { (! loaded) ? <CircularProgress size={24} color="secondary"/> : <SyncIcon /> }
       </IconButton>
      
      </div>
    </div>

    <div className="columns is-mobile">
      <div className="column is-3" style={{maxWidth:"230px"}}>
      </div>
     
      <div className="column" style={{maxWidth: 230*cars.length+"px"}}>

     <Tabs
        centered
        value={transferType}
        indicatorColor="primary"
        textColor="primary"
        onChange={(e, val) => {setTransferType(val)}}
        aria-label="Car type tabs">
           <Tab value={1} label="To" />
           <Tab value={2} label="From"/>
     </Tabs>

      </div>
    </div>

   <div style={{overflowY: "auto"}}>
    <div className="columns is-mobile">
      <div className="column is-3" style={{maxWidth:"230px"}}>
        <div className="header is-size-7">&nbsp;</div>         
        <RegionsTable data={regions}/>
      </div>

      
        {cars.map((car) => {
            
            return (
              <div className="column" style={{maxWidth:"230px"}}>
                <div className="header is-size-7 has-text-centered"><b>{car.name}</b></div>         
                <PricesTable regions={regions} data={prices} ttype={transferType} cartype={car.type_id} />
              </div>
              )

        })}
        
    </div>
    </div>

    </div>
  )

}

export default Prices






const useContentStyles = makeStyles((theme) => ({
  root: {
      overflowY: "initial",
  },
  cell: {
      cursor: "pointer",
  }
}));





export function PricesTable (props) {
  const classes = useStyles()
  const containerClasses = useContentStyles()
  const [open, setOpen] = React.useState(false);
  const [edit, setEdit] = React.useState({})
  const [Rows, setRows] = useState([])
  const dispatch = useDispatch()
  
  let editValueObj = {updateRPrice: {value: true}}

  useEffect(()=>{
    let emptyRow = {ttype_id: props.ttype, car_type: props.cartype, price_azn: "-", price_eur: "-"}
    let Prices = props.data.filter((r) => { return r.ttype_id === props.ttype && r.car_type === props.cartype })

    let Rows = props.regions.map((r) => {
       let dataRow = Prices.find(f=>f.region_id===r.id) || emptyRow
       if (!dataRow.price_azn) dataRow.price_azn = '-'
       if (!dataRow.price_eur) dataRow.price_eur = "-"
       return {region_id: r.id, ...dataRow }
    })

   setRows(Rows)
  }, [props.ttype, props.cartype, props.data])



  const editRow = (data) => {
    setEdit({...data})
    setOpen(true);
  };




  const handleSave = (e, v_editValueObj) => {

    let changeValueObj = helpers.mapElementToValue(v_editValueObj || editValueObj)

    helpers.postAPI(
         { func: function(data) {
              //After receiving response from server
              if (data.status === 'OK') {
                
                console.log('DEBUG','UPDATE_OK',data.new_row)
                dispatch({type: Actions.UPDATE_TRANSFER_PRICE, row: data.new_row})
                 
                if (edit.ttype_id === 1 && changeValueObj.updateRPrice === true) {
                   edit.ttype_id = 2
                   setEdit(edit)
                   handleSave(null, {azn:{value:changeValueObj.azn}, eur:{value:changeValueObj.eur}})
                }

              } else {
                  helpers.closeMessage()
                  helpers.alertMessage('Error on server. '+data.message, globals.ERRO)
              }
          }, 
           uri: globals.myAPIurl+'/postdb',
           data: {what: "price",
                  ttype_id: edit.ttype_id,
                  region_id: edit.region_id,
                  car_type: edit.car_type,
                  column: edit.column,
                  value: changeValueObj}
         })

    setOpen(false);
  };


  const handleClose = () => {
    setOpen(false);
  };





  if (! Rows) return (<div></div>)




  return (
  <section>

      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Change prices for {(edit.region_id) && props.regions.find((r)=>r.id===edit.region_id).name}
    
         </DialogTitle>
        <DialogContent>

            <div className="columns">

                <div className="column">
                <div class="field" style={{maxWidth: "5rem"}}>   
                  <div class="control"> 
                    <TextField
                     id="prices-price-azn"
                     label="AZN"
                     type="number"
                     defaultValue={edit.price_azn === "-" ? null : edit.price_azn}
                     inputRef = {(c)=>editValueObj.azn = c}
                   />
                 </div>
                </div>
                </div>

                <div className="column">
                <div class="field" style={{maxWidth: "5rem"}}>   
                  <div class="control"> 
                    <TextField
                     id="prices-price-eur"
                     label="EUR"
                     type="number"
                     defaultValue={edit.price_eur === "-" ? null : edit.price_eur}
                     inputRef = {(c)=>editValueObj.eur = c}
                   />
                 </div>
                </div>
                </div>
              
              </div>

       <FormControlLabel
        control={
          <Checkbox
            defaultChecked
            onChange={(c)=>editValueObj.updateRPrice = {value: c.target.checked}}
            color="primary"
          />
        }
        label="Update also from price"/>
    
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>





     <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {price_columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Rows.map((row) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.ttype_id+'.'+row.region_id+'.'+row.car_type}>
                  {price_columns.map((column) => {
                    const value = row[column.id];
                    return (
                      
                      <TableCell key={column.id} align={column.align} className={containerClasses.cell} onClick={(e) => editRow({column: column.id, ...row})}>
                   
                         { (column.format) ? column.format(value) : value }
                         
                      </TableCell>
                      
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

   </section>


    )


}
















export function RegionsTable (props) {
  const classes = useStyles()
  const containerClasses = useContentStyles()

  let Rows = props.data

  return (
  <section>

     <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {region_columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Rows.map((row) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                  {region_columns.map((column) => {
                    const value = row[column.id];
                    return (
                      
                      <TableCell key={column.id} align={column.align}>
                   
                         <b>{ (column.format) ? column.format(value) : value }</b>
                         
                      </TableCell>
                      
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

   </section>


    )


}
